// Copyright 2005-2010 Jim Radford <radford@blackbean.org>, David Caldwell <david@porkrind.org>

var piles = require('./piles'), pile_game=piles.pile_game, pile=piles.pile, generic_foundation=piles.generic_foundation,
    in_suit_order=piles.in_suit_order, in_order_by=piles.in_order_by,
    empty_pile_count=piles.empty_pile_count, up=piles.up, king=piles.king;
var piles_ui = require('./piles-ui'), grid = piles_ui.grid;
var seed_game = require('./seed_game'), WON=seed_game.WON;
var solitaire = require('./solitaire').games;

solitaire.sht = class extends pile_game {
    constructor(name, ui) {
        super();
        this.pile_game_init(name, ui);
        this.good = new Array(0);
        this.temp = new Array(0);
        this.work = new Array(0);
        for (let c=1; c<=4; c++) {
            this.good.push(new generic_foundation("good"+c, this));
            this.temp.push(new this.temp_pile("temp"+c, this));
        }
        for (let c=1; c<=this.work_piles; c++)
            this.work.push(new this.work_pile("work"+c, this));
    }

    static {
        this.prototype.temp_pile = class extends pile {
            constructor(div,game) {
                super(div, game);
            }
            accept(card) { return this.pile.length == 0 && this.game.freetemps() >= card.length ? 1 : 0; }
            split_move(start, n, from) {
                    var to = [{from:from,to:this,fstart:start,n:1}];
                    for (var i=1, p=0; p<this.game.temp.length; p++)
                        if (this.game.temp[p].pile.length == 0 && this.game.temp[p] != this && i<n)
                            to.push({from:from,to:this.game.temp[p],fstart:start+i++,n:1});
                    return to.reverse();
            }
            can_drag(index) { return true; }
            xoffset = 0;
            yoffset = 0;
            accept_stacks =  true;
        }

        this.prototype.work_pile = class extends pile {
            constructor(div,game) {
                super(div,game);
            }
            valid_top_card(card) { return card.rank == king; }
            accept(card) {
                    return (this.pile.length      && this.card_order(card[0], this.top())
                            || this.pile.length == 0 && this.valid_top_card(card[0]))
                        && card.length <= this.drag_max(this) ? (this.pile.length ? (in_order_by(this.card_order,this.pile) ? 4 : 3) : 2) : 0;
            }
            drag_max() { return this.game.freetemps() + 1; }
            can_drag(index) {
                    if (this.pile.length - index > this.drag_max())
                        return false;
                    for (var i=index; i<this.pile.length-1; i++)
                        if (!this.card_order(this.pile[i+1], this.pile[i]))
                            return false;
                    return true;
            }
            card_order = in_suit_order;
            xoffset = 0;
            accept_stacks = true;
            maxstack = Math.ceil(6.90469447138699); // Determined by query in upgrades/maxstack.sql
        };

        this.prototype.work_piles = 10;
    }


    deal(deck) {
            this.deck = deck;
            for (var c in this.deck) {
                this.deck[c].face = up;
                this.work[c%this.work.length].push(this.deck[c]);
            }
    }

    freetemps() { return empty_pile_count(this.temp); }

    is_complete() {
            return this.good[0].pile.length == 13 && this.good[1].pile.length == 13 &&
                this.good[2].pile.length == 13 && this.good[3].pile.length == 13 && WON;
    }

    score() {
            return this.count_cards_in(this.good);
    }

    complete() {
            return this.complete_generic(this.good, [this.work, this.temp]);
    }

    layout = grid(["good1", "good2", undefined, "temp1", "temp2", "temp3", "temp4", undefined, "good3", "good4"],
                  ["work1", "work2", "work3",   "work4", "work5", "work6", "work7", "work8",   "work9", "work10"]);
}

module.exports = solitaire.sht;
// Copyright 2005-2010 Jim Radford <radford@blackbean.org>, David Caldwell <david@porkrind.org>

var piles = require('./piles'), pile_game=piles.pile_game, pile=piles.pile, generic_foundation=piles.generic_foundation,
    in_suit_order=piles.in_suit_order, in_order_by=piles.in_order_by,
    empty_pile_count=piles.empty_pile_count, up=piles.up, king=piles.king;
var piles_ui = require('./piles-ui'), grid = piles_ui.grid;
var seed_game = require('./seed_game'), WON=seed_game.WON;
var solitaire = require('./solitaire').games;

solitaire.sht = class extends pile_game {
    constructor(name, ui) {
        super();
        this.pile_game_init(name, ui);
        this.good = new Array(0);
        this.temp = new Array(0);
        this.work = new Array(0);
        for (let c=1; c<=4; c++) {
            this.good.push(new generic_foundation("good"+c, this));
            this.temp.push(new this.temp_pile("temp"+c, this));
        }
        for (let c=1; c<=this.work_piles; c++)
            this.work.push(new this.work_pile("work"+c, this));
    }

    static {
        this.prototype.temp_pile = class extends pile {
            constructor(div,game) {
                super(div, game);
            }
            accept(card) { return this.pile.length == 0 && this.game.freetemps() >= card.length ? 1 : 0; }
            split_move(start, n, from) {
                    var to = [{from:from,to:this,fstart:start,n:1}];
                    for (var i=1, p=0; p<this.game.temp.length; p++)
                        if (this.game.temp[p].pile.length == 0 && this.game.temp[p] != this && i<n)
                            to.push({from:from,to:this.game.temp[p],fstart:start+i++,n:1});
                    return to.reverse();
            }
            can_drag(index) { return true; }
            xoffset = 0;
            yoffset = 0;
            accept_stacks =  true;
        }

        this.prototype.work_pile = class extends pile {
            constructor(div,game) {
                super(div,game);
            }
            valid_top_card(card) { return card.rank == king; }
            accept(card) {
                    return (this.pile.length      && this.card_order(card[0], this.top())
                            || this.pile.length == 0 && this.valid_top_card(card[0]))
                        && card.length <= this.drag_max(this) ? (this.pile.length ? (in_order_by(this.card_order,this.pile) ? 4 : 3) : 2) : 0;
            }
            drag_max() { return this.game.freetemps() + 1; }
            can_drag(index) {
                    if (this.pile.length - index > this.drag_max())
                        return false;
                    for (var i=index; i<this.pile.length-1; i++)
                        if (!this.card_order(this.pile[i+1], this.pile[i]))
                            return false;
                    return true;
            }
            card_order = in_suit_order;
            xoffset = 0;
            accept_stacks = true;
            maxstack = Math.ceil(6.90469447138699); // Determined by query in upgrades/maxstack.sql
        };

        this.prototype.work_piles = 10;
    }


    deal(deck) {
            this.deck = deck;
            for (var c in this.deck) {
                this.deck[c].face = up;
                this.work[c%this.work.length].push(this.deck[c]);
            }
    }

    freetemps() { return empty_pile_count(this.temp); }

    is_complete() {
            return this.good[0].pile.length == 13 && this.good[1].pile.length == 13 &&
                this.good[2].pile.length == 13 && this.good[3].pile.length == 13 && WON;
    }

    score() {
            return this.count_cards_in(this.good);
    }

    complete() {
            return this.complete_generic(this.good, [this.work, this.temp]);
    }

    layout = grid(["good1", "good2", undefined, "temp1", "temp2", "temp3", "temp4", undefined, "good3", "good4"],
                  ["work1", "work2", "work3",   "work4", "work5", "work6", "work7", "work8",   "work9", "work10"]);
}

module.exports = solitaire.sht;
